import add from './add.svg?raw'
import arrow_back_ios from './arrow_back_ios.svg?raw'
import arrow_downward from './arrow_downward.svg?raw'
import arrow_forward_ios from './arrow_forward_ios.svg?raw'
import arrow_upward from './arrow_upward.svg?raw'
import barcode_scanner from './barcode_scanner.svg?raw'
import bomb from './bomb.svg?raw'
import book_5 from './book_5.svg?raw'
import brush from './brush.svg?raw'
import close from './close.svg?raw'
import content_copy from './content_copy.svg?raw'
import cookie from './cookie.svg?raw'
import database from './database.svg?raw'
import delete_ from './delete.svg?raw'
import deselect from './deselect.svg?raw'
import edit_square from './edit_square.svg?raw'
import filter_list from './filter_list.svg?raw'
import flash_off from './flash_off.svg?raw'
import flash_on from './flash_on.svg?raw'
import home from './home.svg?raw'
import info from './info.svg?raw'
import keyboard_arrow_down from './keyboard_arrow_down.svg?raw'
import keyboard_return from './keyboard_return.svg?raw'
import language from './language.svg?raw'
import library_add from './library_add.svg?raw'
import logout from './logout.svg?raw'
import refresh from './refresh.svg?raw'
import search from './search.svg?raw'
import select_all from './select_all.svg?raw'
import settings from './settings.svg?raw'
import shelves from './shelves.svg?raw'
import shelves_off from './shelves_off.svg?raw'
import sort from './sort.svg?raw'
import visibility from './visibility.svg?raw'
import visibility_off from './visibility_off.svg?raw'
import book_search from './book_search.svg?raw'
import scan_barcode from './scan_barcode.svg?raw'
import copy_plus from './copy_plus.svg?raw'
import eye_closed from './eye_closed.svg?raw'
import square from './square.svg?raw'
import eye from './eye.svg?raw'
import square_library from './square_library.svg?raw'
import arrow_left from './arrow_left.svg?raw'
import arrow_right from './arrow_right.svg?raw'
import arrow_up_right from './arrow_up_right.svg?raw'
import edit from './edit.svg?raw'
import share from './share.svg?raw'
import library from './library.svg?raw'
import eye_plus from './eye_plus.svg?raw'
import library_plus from './library_plus.svg?raw'
import save from './save.svg?raw'
import search_x from './search_x.svg?raw'
import discord from './discord.svg?raw'
import playstore from './playstore.svg?raw'
import apple from './apple.svg?raw'
import no_image from './no_image.svg?raw'
import x_logo from './x_logo.svg?raw'
import instagram from './instagram.svg?raw'
import bluesky from './bluesky.svg?raw'
import globe from './globe.svg?raw'
import badge_euro from './badge_euro.svg?raw'
import piggy_bank from './piggy_bank.svg?raw'
import megaphone_off from './megaphone_off.svg?raw'
import user_star from './user_star.svg?raw'
import heart_plus from './heart_plus.svg?raw'
import test from './test.svg?raw'
import megaphone from './megaphone.svg?raw'
import rotate_ccw from './rotate_ccw.svg?raw'
import file_up from './file_up.svg?raw'
import file_down from './file_down.svg?raw'
import user from './user.svg?raw'
import bell from './bell.svg?raw'
import chart_pie from './chart_pie.svg?raw'
import chevron_right from './chevron_right.svg?raw'
import book from './book.svg?raw'
import tag from './tag.svg?raw'
import coins from './coins.svg?raw'
import shopping_basket from './shopping_basket.svg?raw'
import hand_coins from './hand_coins.svg?raw'
import plus from './plus.svg?raw'
import list_plus from './list_plus.svg?raw'
import check from './check.svg?raw'
import layout_grid from './layout_grid.svg?raw'
import list from './list.svg?raw'
import align_justify from './align_justify.svg?raw'
import hard_drive from './hard_drive.svg?raw'
import image from './image.svg?raw'
import sparkle from './sparkle.svg?raw'
import globe_off from './globe_off.svg?raw'
import rotate_ccw_clock from './rotate_ccw_clock.svg?raw'
import globe_x from './globe_x.svg?raw'

export const icons = {
  add,
  arrow_back_ios,
  arrow_downward,
  arrow_forward_ios,
  arrow_upward,
  barcode_scanner,
  bomb,
  book_5,
  brush,
  close,
  content_copy,
  cookie,
  database,
  delete: delete_,
  deselect,
  edit_square,
  filter_list,
  flash_off,
  flash_on,
  home,
  info,
  keyboard_arrow_down,
  keyboard_return,
  language,
  library_add,
  logout,
  refresh,
  search,
  select_all,
  settings,
  shelves,
  shelves_off,
  sort,
  visibility,
  visibility_off,
  book_search,
  scan_barcode,
  copy_plus,
  eye_closed,
  eye,
  square,
  square_library,
  arrow_left,
  arrow_right,
  arrow_up_right,
  edit,
  share,
  library,
  eye_plus,
  library_plus,
  save,
  search_x,
  discord,
  playstore,
  apple,
  no_image,
  x_logo,
  instagram,
  bluesky,
  globe,
  piggy_bank,
  badge_euro,
  megaphone_off,
  user_star,
  heart_plus,
  test,
  megaphone,
  rotate_ccw,
  file_up,
  file_down,
  user,
  bell,
  chart_pie,
  chevron_right,
  book,
  tag,
  coins,
  shopping_basket,
  hand_coins,
  plus,
  list_plus,
  check,
  layout_grid,
  list,
  align_justify,
  hard_drive,
  image,
  sparkle,
  globe_off,
  rotate_ccw_clock,
  globe_x,
} as const

export type IconName = keyof typeof icons
